import actionTypes from '@/api/recipe/store/types/actionTypes';

export default async function (contentType, vm, options = {}) {
  const optionsData = options;

  if (!contentType && typeof contentType !== 'string') {
    throw new Error('You must provide a valid contentType');
  }

  if (!vm) {
    throw new Error('You must provide Vue Instance');
  }

  optionsData.page = options.page || 1;
  optionsData.size = options.size || 1;
  optionsData.queryObject = options.queryObject || {};

  const recipes = await vm.$store.dispatch(actionTypes.RETRIEVE_API_DATAS, {
    options: {
      recipe: {
        take: optionsData.size,
        page: optionsData.page,
      },
    },
    queryObject: { ...optionsData.queryObject, ...{ approve: 1 } },
  });

  const transformerOptions = {
    data: (recipes.data || [])
  };

  return optionsData.transformer ? optionsData.transformer(vm, transformerOptions) : recipes.data;
}
